

const ptBr = {
  rules: {
    cpfLabel: 'Preencha o CPF',
    passwordLabel: 'A senha não pode ser vazia',
    passwordLabelJustNumbers: 'Senha deve conter somente números.',
    passwordLabel2EqualNumbers: 'Senha não pode ter 2 números iguais seguidos.',
    passwordLabel3EqualNumbers: 'Senha não pode ter 3 números sequenciais.',
    passwordMin6Characteres: 'A senha deve ter 6 números.',
    emailLabel: 'Preencha o e-mail',
    emailLabelInvalid: 'E-mail inválido.',
    cepLabel: 'Preencha o CEP',
    invalidCepLabel: 'CEP inválido',
    estadoCivilLavel: 'Estado Civil é obrigatório.',
    estadoCivilComNomeLabel:
      'Não é possível alterar o Nome sem alterar o Estado Civil.',
    comprovanteLabel: 'Comprovante é obrigatório.',
    telefoneInvalidoLabel: 'Telefone inválido',
    telefoneMaiorQueZeroLabel: 'Telefone não pode iniciar com zero.',
    celularInvalidoLabel: 'Celular inválido',
    celularMaiorQueZeroLabel: 'Celular não pode iniciar com zero.',
    nomeObrigatorioLabel: 'Nome é obrigatório.',
    logradouroObrigatorioLabel: 'Logradouro é obrigatório.',
    ufObrigatorioLabel: 'UF é obrigatório.',
    grauInstrucaoObrigatorio: 'Grau de Instrução é obrigatório.',
    cidadeLabel: 'Cidade é obrigatório',
    matriculaLabel: 'Matrícula da Certidão é obrigatório.',
    observacaoLabel: 'Observação é obrigatório.',
    comprovanteLabel: 'Comprovante é obrigatório.',
    dataLabel: 'Preencha a data.',
    dataInvalidaLabel: 'Data inválida.',
    perguntaLabel: 'Está pergunta é obrigatória',
    grauInstrucaoObrigatorioLabel: 'Preencha o grau de instrução'
  },
  screen: {
    login: {
      contact: `Identificamos em nosso banco de dados que ja existe um cadastro com este CPF, no entanto não existe senha informada para este acesso.  
          Por favor entre em contato com o RH de nossa empresa através do número (37) 3286 - 2600 para que seu cadastrado seja atualizado e uma senha seja implementada no seu cadastro. 
          Obrigado!`,
      messageCardLeft:
        'Bem vindo ao Portal do Colaborador, um jeito fácil e prático de acessar suas informações, comprovantes e orientações.',
      serviceNotFound: 'Serviço Indisponível',
      form1: {
        title: 'Acesso ao Portal',
        label:
          'Para acessar o Portal do Colaborador basta informar seu CPF e senha!',
        passwordLabel: 'Senha',
        rememberLabel: 'Lembrar-me',
        btnLoginLabel: 'Logar',
      },
      dialog1: {
        title: 'Aviso!',
        askMessagePassword: 'Como deseja recuperar sua senha?',
        btnChangePasswordLabel: 'TROCAR SENHA',
        btnCancelLabel: 'CANCELAR',
        btnSendLabel: 'ENVIAR',
        smsOK: 'WhatsApp enviado com sucesso!',
        smsError: 'Ops... Não foi possível enviar o WhatsApp!',
        emailOK: 'E-mail enviado com sucesso!',
        emailError: 'Ops... Não foi possível enviar o E-mail!',
        passwordRecoveryError:
          'Nenhuma opçao de recuperação de senha disponível. Entre em contato com o setor de Recursos Humanos.',
        passwordOptionsRecovery:
          'Opções disponíveis para recuperação de senha: \n',
        phoneNotValid:
          'Não foi encontrado um número de telefone válido no seu cadastro.',
        smsNumber:
          'Você pode recuperar sua senha, atráves de um WhatsApp enviado para o número ',
        noSmsNumber:
          'Numero não encontrado',
        emailNotFound: 'Não foi encontrado um e-mail válido no seu cadastro.',
        emailNumber:
          'Você pode recuperar sua senha, atráves de um e-mail enviado para o endereço ',
        emailAndNumberNotFound:
          'Nenhuma opçao de recuperação de senha disponível. Entre em contato com a empresa.',
        wrongPass: 'SENHA INVÁLIDA',
        wrongPass1: 'Caso você não lembre a sua senha, entre em contato com o Departamento Pessoal da empresa para redefinir/cadastrar uma nova senha.',
        wrongLogin: 'Não foi possível realizar o login. \n ',
        cpfNotFound:
          'Identificamos que o CPF informado não está na base de dados, por favor verifique os dados informados.',
        passNotFound:
          'Identificamos que o CPF informado não possui senha cadastrada no sistema, por favor entre em contato com a empresa.',
        personNotFound:
          'Identificamos que o CPF informado não está vinculado a nenhum colaborador cadastrado no sistema. Por favor verifique os dados informados ou entre em contato com a empresa.',
      },
      dialog2: {
        title: 'Alterar senha!',
        message:
          'Você possui a senha padrão de acesso, Para sua segurança altere sua senha!!!',
        btnNewPasswordLabel: 'Nova senha',
        btnCancelLabel: 'Fechar',
        btnUpdateLabel: 'Alterar',
      },
    },
    cgiCardDependente: {
      btnBenefits: 'Benefícios',
      benefits: 'Benefícios',
      btnClose: 'Fechar',
    },
    footer: {
      name: 'Portal do Colaborador',
      version: 'Versão',
    },
    navDrawerRight: {
      wellcome: 'Bem vindo',
      user: 'Usuário',
      btnLogout: 'Sair',
    },
    toolbar: {
      wellcome: 'Bem vindo',
      start: 'Inicio',
      imageAlt: 'Imagem de perfil',
      btnChangePass: 'Alterar Senha',
      btnWarnings: 'Avisos',
      showAllWarnigs: 'Visualizar todos avisos.',
      btnLogout: 'Sair',
      labelChangePass: 'Nova senha',
      passUpdatedOK: 'Senha alterada com sucesso!',
      passUpdatedWrong: 'Não foi possível alterar a senha',
    },
    formDadosCadastrais: {
      nameLavel: 'Nome',
      phoneLabel: 'Telefone',
      celLavel: 'Celular',
      emailLabel: 'E-mail',
      logradouroLabel: 'Logradouro',
      enderecoLabel: 'Endereço',
      numeroLabel: 'Número',
      complementoLabel: 'Complemento',
      bairroLabel: 'Bairro',
      cidadeLabel: 'Cidade',
      estadoCivilLabel: 'Estado Civil',
      conjugeLabel: 'Conjuge',
      grauInstrucaoLabel: 'Grau de Instrução',
      observacaoLabel: 'Observação',
      comprovanteLabelNome: 'Comprovante de alteração de nome (Certidão)',
      comprovanteLabelInfoNome:
        'Anexe neste campo a certidão que comprove a mudança de nome!',        
      comprovanteLabelEndereco: 'Comprovante de residência',
      comprovanteLabelInfoEndereco:
        'Anexe neste campo um comprovante de Endereço (conta de luz, agua, etc)',                
      comprovanteLabelEstadoCivil: 'Comprovante da alteração do Estado Civil (Certidão)',
      comprovanteLabelInfoEstadoCivil:
        'Anexe neste campo um comprovante da alteração do estado civil!',                        
      comprovanteLabelGrauInstrucao: 'Comprovante de Escolaridade',
      comprovanteLabelInfoGrauInstrucao:
        'Anexe neste campo um comprovante da escolaridade (diploma, certidão, etc)',                                
      comprovanteLabelImagem: 'FOTO (nova imagem para o cadastro)',
      comprovanteLabelInfoImagem:
        'Caso desejar, anexe uma nova imagem !',                                        
      btnCancelar: 'Cancelar',
      btnVoltar: 'Voltar',
      btnGravar: 'Gravar',
      btnAvancar: 'Avançar',
      error01Label:
        'É necessário modificar ao menos um campo para solicitar uma alteração cadastral.',
      error02Label:
        'A sua solicitação de alteração de dados cadastrais, foi recebida com sucesso. \nEm breve ela será analisada pelos responsáveis.',
      error03Label: 'Erro no Upload de comprovante de Atualização Cadastral.',
      error04Label:
        'A sua solicitação de alteração de dados cadastrais não pode ser concluída, porque não foi possível enviar o comprovante, entre em contato com a empresa.',
      error05Label:
        'A sua solicitação de alteração de dados cadastrais, foi recebida com sucesso. \nPorém não foi possível enviar o comprovante, entre em contato com a empresa.',
      error06Label: 'Não foi possível solicitar a atualização cadastral.',
    },
    formDependenteResponsivo: {
      nomeLabel: 'Nome',
      sexoLabel: 'Sexo',
      masculinoLabel: 'Masculino',
      femininoLabel: 'Feminino',
      grauDependenciaLabel: 'Grau de Dependência',
      cpfLabel: 'CPF',
      nascimentoLabel: 'Nascimento',
      nomePaiLabel: 'Nome do pai',
      nomeMaeLabel: 'Nome da mãe',
      cidadeLabel: 'Cidade',
      numCeridaoLabel: 'Nº Certidão',
      livroLabel: 'Livro',
      folhaLabel: 'Folha',
      matriculaCertidaoLabel: 'Matricula da certidão',
      dataCertidaoLabel: 'Data da certidão',
      estudanteLabel: 'Estudante',
      necessidadesEspeciaisLabel: 'Portador de Necessidade Especial',
      tipoNecessidadesEspeciaisLabel: 'Tipo da Necessidade Especial',
      observacaoLabel: 'Observação',
      comprovanteLabel: 'Comprovante',
      btnCancelar: 'Cancelar',
      btnVoltar: 'Voltar',
      btnGravar: 'Gravar',
      btnAvancar: 'Avançar',
      error01Label:
        'A sua solicitação de inclusão de dependente, foi recebida com sucesso. Em breve ela será analisada pelos responsáveis.',
      error02Label: 'Erro no Upload de comprovante de Dependentes.',
      error03Label:
        'A sua solicitação de inclusão de dependente não pode ser concluída, porque não foi possível enviar o comprovante, entre em contato com a empresa.',
      error04Label:
        'A sua solicitação de inclusão de dependente, foi recebida com sucesso. Porém não foi possível enviar o comprovante, entre em contato com a empresa.',
      error05Label: 'Não foi possível solicitar a atualização cadastral.',
    },
    avaliacaoClima: {
      descricaoLabel: 'Descrição',
      naoSeAplica: 'Essa pergunta não se aplica a mim.',
    },
    avisos: {
      tituloLabel: 'Avisos',
      possuiAnexosLavel: 'Ver anexos.',
      naoTemAvisosLabel: 'Você ainda não possui nenhum aviso.',
    },
    beneficios: {
      tituloLabel: 'Benefícios',
      table01: {
        header01: 'Descricao',
        header02: 'Nome da Empresa',
        header03: 'Valor Mês',
        header04: 'Valor acumulado do ano',
      },
      error01Label: 'Não há dados disponíveis',
    },
    comprasVarejo: {
      tituloLabel: 'Compras de Varejo',
      error01Label: 'Não há dados disponíveis',
      table01: {
        header01: 'Data da Venda',
        header02: 'Nota fiscal',
        header03: 'Valor',
      },
    },
    comprovantes: {
      tituloLabel: 'Comprovantes',
      string001: 'Ref:',
      string002: 'Recibo de',
      string003: 'disponível',
      string004: 'IMPRIMIR',
      string005: 'Impressão do comprovante em PDF.',
      string006: 'Proventos',
      string007: 'Descontos',
      string008: 'Líquido',
      string009: 'Detalhes',
      string010: 'Fechar',
      string011: 'Base FGTS',
      string012: 'Valor FGTS',
    },
    dadosCadastrais: {
      string001: 'Dados Pessoais',
      string002: 'Dados Contratuais',
      string003: 'Atualizar Cadastro',
      string004: 'Benefícios',
      string005: 'Fechar',
      string006: 'Aviso!',
      string007: 'Fone',
      string008: 'Celular',
      string009: 'E-mail',
      string010: 'Estado civil',
      string011: 'Grau de instrução',
      string012: 'Empresa',
      string013: 'CNPJ',
      string014: 'Cargo',
      string015: 'Unidade',
      string016: 'Admissão',
      string017: 'Salário',
      string018: 'Supervisor',
      table01: {
        header01: 'Tipo',
        header02: 'Descrição',
        header03: 'Campo 2',
        header04: 'Campo 3',
        header05: 'Campo 4',
      },
      error001:
        'Existe uma solicitação de atualização de dados cadastrais pendente, aguarde a revisão ser concluída e tente novamente.',
      error002:
        'Não foi é possível atualizar seus dados cadastrais. Tente novamente mais tarde ou entre em contato com a empresa.',
    },
    dependentes: {
      string001: 'Dependentes',
      string002: 'Adicionar Dependente',
      string003: 'Aviso!',
    },
    error404: {
      string001: 'Página não encontrada.',
      string002: 'Página inicial',
    },
    espelhoDoPonto: {
      string001: 'Espelho do Ponto',
      string002: 'Ref:',
      string003: 'Recibo de',
      string004: 'Espelho do Ponto',
      string005: 'Disponível',
      string006: 'IMPRIMIR',
      string007: 'Impressão do comprovante em PDF.',
    },
    faleComRH: {
      string001: '#FaleComRH',
      string002: 'Motivos',
      string003: 'Solicitação',
      string004: 'Descreva a solicitação',
      string005: 'ENVIAR',
      string006: 'Dados enviados com sucesso!',
      string007: 'Anexo',
      string008: 'Histórico',
    },
    home: {
      string001: 'Funcionalidades',
      string002: 'Estatísticas',
      string003: 'Algumas estatísticas',
      string004: 'de aumento',
      string005: 'Atualizado há 4 minutos',
      string006: 'Estatísticas Principais',
      string007: 'Atualizado há 10 minutos',
      string008: 'Portal do Colaborador',
      string009: 'Comprovantes',
      string010: 'Informe de Rendimentos',
      string011: 'Dados Cadastrais',
      string012: 'Dependentes',
      string013: 'Avisos',
      string014: 'Telefonia Móvel',
      string015: 'Compras de Varejo',
      string016: 'Ponto e PIP',
      string017: 'Espelho do Ponto',
      string018: 'Benefícios',
      string019: 'Avaliações e Pesquisas',
      string020: '#FalecomRH',
      string021: 'Marcações do ponto',
      string022: 'Varejo',
      string023: 'Normas/Notícias',
      string024: 'Programação de Férias',
      string025: 'Documentos Assinados/À Assinar',
      string026: 'Ajuste de Ponto',
      string027: 'Oportunidades Internas',
      string028: 'Reserva de Restaurante',
      string029: 'Vale Refeição',
      string030: 'Horas não Trabalhadas',
      string031: 'Pontualidade',
    },
    informesRendimentos: {
      string001: 'Informe de Rendimentos',
      string002: 'Ref:',
      string003: 'IMPRIMIR',
      string004: 'Impressão do comprovante em PDF.',
      string005: 'Informe de rendimentos não encontrado',
      string006: 'Informe de Rendimentos Disponível',
      string007: 'Informe de Rendimentos Indisponível',
    },
    marcacoesPonto: {
      string001: 'Marcações do ponto',
      string002: 'Código Empregado',
      string003: 'Unidade',
      string004: 'Cargo',
      table01: {
        header01: 'Data',
        header02: 'Dia da Semana',
        header03: 'Horário',
        header04: 'Marcações',
      },
      string005: 'Horas Extras 50%',
      string006: 'Horas Extras 100%',
      string007: 'Faltas Justificadas',
      string008: 'Faltas Injustificadas',
      string009: 'Horas Extras 60%',
      string010: 'Saldo Banco Horas',
    },
    pip: {
      string001: 'Ponto e PIP',
      string002: 'Detalhes',
      string003: 'Janeiro',
      string004: 'Fevereiro',
      string005: 'Março',
      string006: 'Abril',
      string007: 'Maio',
      string008: 'Junho',
      string009: 'Julho',
      string010: 'Agosto',
      string011: 'Setembro',
      string012: 'Outubro',
      string013: 'Novembro',
      string014: 'Dezembro',
      string015: 'Média',
      string016: 'Nota final',
      string017: 'Data ocorrência',
      string018: 'Quantidade',
    },
    telefonia: {
      string001: 'Telefonia Móvel',
      string002: 'Data Inicial',
      string003: 'Data Final',
      table01: {
        header01: 'Data',
        header02: 'Observação',
      },
    },
    cartilha: {
      string001: 'Normas/Notícias ao Funcionário',
      string002: 'IMPRIMIR',
    },
    programacao: {
      string001: 'Programação de Férias',
    },
    documentos: {
      string001: 'Documentos Assinados/À Assinar Eletronicamente',
      string002: 'IMPRIMIR',
      string003: 'Assinar',
    },
    agendaAvaliacao: {
      string001: 'Avaliações Pendentes',
      string002: 'Responder',
    },
    inclusaoPonto: {
      string001: 'Solicitaçao de Ajuste de Ponto',
    },
    oportunidades: {
      string001: 'Lista de oportunidades internas',
    },
    reserva: {
      string001: 'Reserva de Restaurante',
    },
    valerefeicao: {
      string001: 'Vale Refeição',
      string002: 'Data Inicial',
      string003: 'Data Final',
      table01: {
        header01: 'Situação',
        header02: 'Evento',
        header03: 'Descrição',
        header04: 'Competência',
        header05: 'Valor',
      },
    },
    pontoTeletex: {
      string001: 'Inclusão de Marcação',
      string002: 'Exclusão de Marcação',
      string003: 'Hora não Trabalhada (HNT)',
      string004: 'Solicitar Folga',
      string005: 'Solicitar Pontualidade',
      string006: 'Solicitação de Ajuste',
      string007: 'Hora Extra',
    },
     pontualidadeTeletex: {
      string001: 'Pontualidade',
      string002: 'Data Inicial',
      string003: 'Data Final',
      table01: {
        header01: 'Empregado',
        header02: 'Competência',
        header03: 'Evento',
        header04: 'Nome do Evento',
        header05: 'Valor',
        header06: 'Horas',
        header07: 'Meses',
      },
    },

    
    denuncia: {
      string001: 'Canal de Denúncias',
      string002: 'Como você se identifica?',
      string003: 'Nome da vítima (Caso queira identificar)',
      string004: 'Informe o nome da vítima (Caso queira identificar)',
      string005: 'Nome do(a) ofensor(a)',
      string006: 'Informe o nome do(a) ofensor(a)',
      string007: 'O fato que será relatado é?',
      string008: 'Quando ocorreu?',
      string009: 'Informe com detalhes quando ocorreu o fato',
      string010: 'Houve testemunhas?',
      string011: 'Indique o nome ou nomes',
      string012: 'Informe o nome ou nomes das pessoas que testemunharam o fato',
      string013: 'Descreva o ocorrido',
      string014: 'Registre o máximo de informações possíveis, cada detalhe conta',
      string015: 'Denúncia gravada com Sucesso!',
    },
  },
}

export default ptBr
